import { useState } from "react";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { notifyForm } from "@/lib/notifyForm";

export function HeroBookingForm({ tagline, heading }: { tagline: string; heading?: string }) {
  const [submitting, setSubmitting] = useState(false);
  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const name = String(fd.get("name") ?? "").trim();
    const phone = String(fd.get("phone") ?? "").trim();
    if (name.length < 2) return toast.error("Please enter your name");
    if (!/^[0-9+\-\s()]{7,20}$/.test(phone)) return toast.error("Please enter a valid phone");
    setSubmitting(true);
    const ok = await notifyForm({
      formType: "Quick Consultation Request",
      source: tagline,
      fields: [
        { label: "Name", value: name },
        { label: "Phone", value: phone },
      ],
    });
    setSubmitting(false);
    if (ok) {
      toast.success("Thank you! Our care team will call you shortly.");
      form.reset();
    } else {
      toast.error("Could not submit. Please call +91 95887 95887.");
    }
  };
  return (
    <div className="rounded-2xl bg-card p-5 text-foreground shadow-card sm:p-6">
      <p className="text-xs font-semibold text-accent">{tagline}</p>
      <h2 className="mt-1 font-display text-lg font-bold leading-tight sm:text-xl">
        {heading ?? "Connect with your health counsellor today!"}
      </h2>
      <form onSubmit={onSubmit} className="mt-4 space-y-3">
        <div>
          <label className="text-xs text-muted-foreground">What is your name?</label>
          <input name="name" placeholder="Enter your name" className="mt-1 h-10 w-full rounded-lg border border-border bg-background px-3 text-sm outline-none focus:border-accent" required />
        </div>
        <div>
          <label className="text-xs text-muted-foreground">How to connect with you?</label>
          <input name="phone" inputMode="tel" placeholder="Enter your phone number" className="mt-1 h-10 w-full rounded-lg border border-border bg-background px-3 text-sm outline-none focus:border-accent" required />
        </div>
        <p className="flex items-center gap-1.5 text-[11px] text-muted-foreground">
          <Lock className="h-3 w-3 text-green-600" /> Your details are 100% secured
        </p>
        <button type="submit" disabled={submitting} className="w-full rounded-lg bg-primary px-5 py-3 text-sm font-semibold text-primary-foreground hover:opacity-90 disabled:opacity-60">
          {submitting ? "Submitting..." : "Book a Consultation"}
        </button>
      </form>
    </div>
  );
}
